import { getApiToken, verifyApiToken } from "../api/token.api";
import { Permission } from "../models/message.model";

const ACCESS_TOKEN_KEY = "accessToken"; // Example: storing in localStorage (NOT RECOMMENDED for production)

export class AuthService {
  private accessToken: string | null = null;

  constructor() {
    // Attempt to load token from storage on initialization (if using storage)
    const storedToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (storedToken) {
      this.accessToken = storedToken;
    }
  }

  // Set the access token after successful login
  setAccessToken(token: string): void {
    this.accessToken = token;
    localStorage.setItem(ACCESS_TOKEN_KEY, token); //   Not recommended for production (use HttpOnly cookies or in-memory)
  }

  // Get the current access token
  getAccessToken(): string | null {
    return this.accessToken;
  }

  // Clear the access token on logout
  clearAccessToken(): void {
    this.accessToken = null;
    localStorage.removeItem(ACCESS_TOKEN_KEY); // Also remove from storage
  }

  // Simulate token expiry check (in a real app, this would involve JWT decoding)
  async isTokenExpired(): Promise<boolean> {
    let status = false;
    const token = this.getAccessToken();
    if (token) {
      try {
        const res = await verifyApiToken(token);
        status = false;
      } catch (err) {
        status = true;
      }
    }
    return status;
  }

  // // Simulate token refresh (backend call to get a new access token)
  // async refreshAccessToken(): Promise<boolean> {
  //   try {
  //     // In a real scenario, you'd send the refresh token (from HttpOnly cookie) to your backend
  //     const response = await fetch("/api/refresh-token", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         refreshToken: /* Get refresh token from HttpOnly cookie */ "",
  //       }),
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       this.setAccessToken(data.accessToken); // Update the new access token
  //       return true;
  //     }
  //     return false;
  //   } catch (error) {
  //     console.error("Error refreshing token:", error);
  //     return false;
  //   }
  // }

  async setNewToken() {
    this.clearAccessToken();
    const res = await getApiToken({ authorize: Permission.View });
    if (res.status !== 200) {
      console.log("failed to get access token");
    }
    const token = res.data.token;
    if (token) {
      this.setAccessToken(token);
    } else {
      console.log("token not found in response.");
    }
  }
}

export const authService = new AuthService(); // Singleton instance
